// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ProfileLoading_componentWrapper__orgw0","progress":"ProfileLoading_progress__DdYpL"};